//Icons
export { default as BagIcon } from './BagIcon'
export { default as CardIcon } from './cards/CardIcon'
export { default as PressIcon } from './press/PressIcon'
export { default as Chevron } from './Chevron'
export { default as GuaranteeIcon } from './GuaranteeIcon'
export { default as MailboxIcon } from './MailboxIcon'
export { default as Ruler } from './Ruler'
export { default as XIcon } from './XIcon'
export * from './AIcon'
export * from './Checkmark'
export * from './CircleChevron'
export * from './Hamburger'
export * from './Logo'
export * from './Spinner'



// WEBPACK FOOTER //
// ./src/core/icons/index.js